(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["family-reunion-launch-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      const root = document.querySelector('shopify-forms-embed#app-embed')?.shadowRoot;
      const phone = root?.querySelector('input[name="phone_number"]');
      const consent = root?.querySelector('input[name="custom#quote_contact_consent"]');

      [phone, consent].forEach((field) => {
        if (!field) return;

        field.required = true;
        field.setAttribute('aria-required', 'true');

        const label = root.querySelector(`label[for="${CSS.escape(field.id)}"]`);
        if (label && !label.querySelector('[data-fr-required]')) {
          const marker = document.createElement('span');
          marker.dataset.frRequired = 'true';
          marker.setAttribute('aria-hidden', 'true');
          marker.textContent = ' *';
          label.appendChild(marker);
        }
      });

      if ((phone && consent) || attempts >= 60) {
        window.clearInterval(timer);
      }
    }, 250);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-graphco-bundle-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRetail = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('.lfg-universal-bundle__retail-form');
      const optionFields = Array.from(root.querySelectorAll('[data-retail-option]'));
      const quantityField = root.querySelector('[data-retail-quantity]');
      const personalizationField = root.querySelector('[data-retail-personalization]');
      const unitPriceNode = root.querySelector('[data-retail-unit-price]');
      const priceQuantityNode = root.querySelector('[data-retail-price-quantity]');
      const subtotalNode = root.querySelector('[data-retail-subtotal]');
      const formError = root.querySelector('[data-retail-error]');
      const modal = root.querySelector('[data-retail-modal]');
      const modalPanel = modal.querySelector('.lfg-universal-bundle__modal-panel');
      const editButton = root.querySelector('[data-retail-edit]');
      const buyButton = root.querySelector('[data-retail-buy]');
      const buyButtonLabel = buyButton.textContent.trim();
      const modalError = root.querySelector('[data-retail-modal-error]');
      const modalColor = root.querySelector('[data-retail-modal-color]');
      const modalSize = root.querySelector('[data-retail-modal-size]');
      const modalQuantity = root.querySelector('[data-retail-modal-quantity]');
      const modalUnit = root.querySelector('[data-retail-modal-unit]');
      const modalSubtotal = root.querySelector('[data-retail-modal-subtotal]');
      const currency = root.dataset.currency || 'USD';
      let variants = [];
      let messages = {};
      let pendingState = null;

      try {
        variants = JSON.parse(root.querySelector('[data-retail-variants]').textContent || '[]');
        messages = JSON.parse(root.querySelector('[data-retail-messages]').textContent || '{}');
      } catch (error) {
        variants = [];
        messages = {};
      }

      const money = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(cents / 100);

      const selection = () => {
        const selected = [];
        optionFields.forEach((field) => {
          selected[Number(field.dataset.optionIndex)] = field.value;
        });
        const rawQuantity = quantityField.value.trim();
        const quantity = rawQuantity === '' ? NaN : Number(rawQuantity);
        const validQuantity = Number.isInteger(quantity) && quantity > 0;
        const complete = optionFields.every((field) => field.value !== '');
        const variant = complete
          ? variants.find((candidate) => candidate.options.every((value, index) => selected[index] === value))
          : null;
        const price = variant ? Number(variant.price) : 0;
        return {
          selected,
          quantity,
          validQuantity,
          complete,
          variant,
          price,
          subtotal: validQuantity ? price * quantity : 0
        };
      };

      const update = () => {
        const state = selection();
        unitPriceNode.textContent = state.variant ? money(state.price) : '—';
        priceQuantityNode.textContent = state.validQuantity ? String(state.quantity) : '—';
        subtotalNode.textContent = state.variant && state.validQuantity ? money(state.subtotal) : '—';
      };

      const selectedValue = (name) => {
        const field = optionFields.find((item) => {
          const label = root.querySelector('label[for="' + item.id + '"]');
          return label && label.textContent.trim().toLowerCase().startsWith(name.toLowerCase());
        });
        return field ? field.value : '';
      };

      const closeModal = (focusTarget) => {
        modal.hidden = true;
        document.body.style.overflow = modal.dataset.previousBodyOverflow || '';
        modalError.hidden = true;
        modalError.textContent = '';
        pendingState = null;
        if (focusTarget) focusTarget.focus();
      };

      const openModal = (state) => {
        modalColor.textContent = selectedValue('Color');
        modalSize.textContent = selectedValue('Size');
        modalQuantity.textContent = String(state.quantity);
        modalUnit.textContent = money(state.price);
        modalSubtotal.textContent = money(state.subtotal);
        modalError.hidden = true;
        modalError.textContent = '';
        buyButton.disabled = false;
        buyButton.textContent = buyButtonLabel;
        pendingState = state;
        modal.dataset.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        modal.hidden = false;
        modalPanel.scrollTop = 0;
        modalPanel.focus({ preventScroll: true });
      };

      form.addEventListener('input', update);
      form.addEventListener('change', update);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const state = selection();
        if (!form.checkValidity() || !state.complete || !state.validQuantity) {
          form.reportValidity();
          formError.hidden = false;
          formError.textContent = messages.required;
          formError.focus();
          return;
        }
        if (!state.variant || !state.variant.available) {
          formError.hidden = false;
          formError.textContent = messages.unavailable;
          formError.focus();
          return;
        }
        formError.hidden = true;
        formError.textContent = '';
        openModal(state);
      });

      editButton.addEventListener('click', () => closeModal(optionFields[0] || quantityField));
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal(optionFields[0] || quantityField);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [editButton, buyButton].filter((button) => !button.disabled);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      buyButton.addEventListener('click', async () => {
        if (!pendingState || buyButton.disabled) return;
        const state = pendingState;
        const properties = {
          'Configurator mode': root.dataset.mode === 'open_custom' ? 'Open-quantity custom garment' : 'Single retail garment',
          'Selected color': selectedValue('Color'),
          'Selected size': selectedValue('Size'),
          'Configured merchandise subtotal': money(state.subtotal)
        };
        if (personalizationField && personalizationField.value.trim()) {
          properties['Optional city or date line'] = personalizationField.value.trim();
        }
        buyButton.disabled = true;
        buyButton.textContent = messages.adding;
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(state.variant.id), quantity: state.quantity, properties }]
            })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || messages.addError);
          window.location.assign(window.Shopify.routes.root + 'checkout');
        } catch (error) {
          modalError.hidden = false;
          modalError.textContent = error.message || messages.addError;
          modalError.focus();
          buyButton.disabled = false;
          buyButton.textContent = buyButtonLabel;
        }
      });

      update();
    };

    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('.lfg-universal-bundle__form');
      const sizeInputs = Array.from(root.querySelectorAll('.lfg-universal-bundle__size'));
      const totalNode = root.querySelector('[data-bundle-total]');
      const sizeMessage = root.querySelector('[data-size-message]');
      const additionsNode = root.querySelector('[data-bundle-additions]');
      const finalNode = root.querySelector('[data-bundle-final]');
      const pricingAlert = root.querySelector('[data-pricing-alert]');
      const formError = root.querySelector('[data-form-error]');
      const submitButton = root.querySelector('[data-bundle-submit]');
      const modal = root.querySelector('[data-price-modal]');
      const modalPanel = modal.querySelector('.lfg-universal-bundle__modal-panel');
      const modalEditButton = root.querySelector('[data-modal-edit]');
      const modalBuyButton = root.querySelector('[data-modal-buy]');
      const modalBuyLabel = modalBuyButton.textContent.trim();
      const modalError = root.querySelector('[data-modal-error]');
      const modalColor = root.querySelector('[data-modal-color]');
      const modalPrintColor = root.querySelector('[data-modal-print-color]');
      const modalTotal = root.querySelector('[data-modal-total]');
      const modalSizes = root.querySelector('[data-modal-sizes]');
      const modalBase = root.querySelector('[data-modal-base]');
      const modalAdditions = root.querySelector('[data-modal-additions]');
      const modalSubtotal = root.querySelector('[data-modal-subtotal]');
      const targetQuantity = Number(root.dataset.packageQuantity);
      const baseCents = Number(root.dataset.baseCents);
      const currency = root.dataset.currency || 'USD';
      const unitSingular = root.dataset.unitSingular;
      const unitPlural = root.dataset.unitPlural;
      const colorProperty = root.dataset.colorProperty;
      const surcharges = {
        '2xl': Number(root.dataset.surchargeTwoXl),
        '3xl': Number(root.dataset.surchargeThreeXl),
        '4xl': Number(root.dataset.surchargeFourXl),
        '5xl': Number(root.dataset.surchargeFiveXl)
      };
      const sizeLabels = {
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
        xl: 'XL',
        '2xl': '2XL',
        '3xl': '3XL',
        '4xl': '4XL',
        '5xl': '5XL'
      };

      let editContext = null;
      let restoring = true;
      let saveInFlight = false;
      let saved = false;
      let messages = {};
      let tiers = [];
      let pendingState = null;
      let modalReturnFocus = null;
      try {
        messages = JSON.parse(root.querySelector('[data-bundle-messages]').textContent || '{}');
        tiers = JSON.parse(root.querySelector('[data-price-tier-variants]').textContent || '[]');
      } catch (error) {
        messages = {};
        tiers = [];
      }
      const variantByPrice = new Map(tiers.map((tier) => [Number(tier.price), String(tier.id)]));

      const money = (cents) => new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(cents / 100);

      const compactMoney = (cents) => cents % 100 === 0
        ? new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(cents / 100)
        : money(cents);

      const quantities = () => Object.fromEntries(sizeInputs.map((input) => {
        const raw = input.value.trim();
        const value = raw === '' ? 0 : Number(raw);
        return [input.dataset.size, Number.isInteger(value) && value >= 0 ? value : NaN];
      }));

      const pricingState = () => {
        const values = quantities();
        const invalidNumber = Object.values(values).some((value) => !Number.isFinite(value));
        const total = invalidNumber ? NaN : Object.values(values).reduce((sum, value) => sum + value, 0);
        const additions = invalidNumber ? 0 : Object.entries(surcharges)
          .reduce((sum, entry) => sum + values[entry[0]] * entry[1], 0);
        const configuredCents = baseCents + additions;
        const variantId = invalidNumber ? null : variantByPrice.get(configuredCents);
        return { values, invalidNumber, total, additions, configuredCents, variantId };
      };

      const replaceToken = (text, token, value) => String(text || '').split(token).join(String(value));

      const currentForm = () => root.querySelector('.lfg-universal-bundle__form');

      const currentFieldValue = (fieldId) => {
        const field = root.querySelector('#' + CSS.escape(fieldId));
        return field ? String(field.value || '').trim() : '';
      };

      const activeRequiredControls = (formElement) => Array.from(formElement.querySelectorAll('[required]'))
        .filter((control) => !control.disabled && control.type !== 'hidden' && !control.closest('[hidden]'));

      const refreshRequiredValidity = (formElement) => {
        activeRequiredControls(formElement).forEach((control) => {
          if (control.matches('input[type="text"], input[type="url"], textarea')) {
            control.setCustomValidity(String(control.value || '').trim() === '' ? messages.requiredError : '');
          }
        });
      };

      const validateCurrentRequiredState = (formElement, report) => {
        refreshRequiredValidity(formElement);
        const valid = formElement.checkValidity();
        if (!valid && report) formElement.reportValidity();
        return valid;
      };

      const update = () => {
        const state = pricingState();
        const formElement = currentForm();
        refreshRequiredValidity(formElement);
        totalNode.textContent = state.invalidNumber ? '—' : String(state.total);
        additionsNode.textContent = money(state.additions);
        finalNode.textContent = money(state.configuredCents);

        if (state.invalidNumber) {
          sizeMessage.textContent = messages.invalidNumber;
          sizeMessage.dataset.state = 'invalid';
        } else if (state.total < targetQuantity) {
          sizeMessage.textContent = replaceToken(messages.moreNeeded, '[count]', targetQuantity - state.total);
          sizeMessage.dataset.state = 'invalid';
        } else if (state.total > targetQuantity) {
          sizeMessage.textContent = replaceToken(messages.removeNeeded, '[count]', state.total - targetQuantity);
          sizeMessage.dataset.state = 'invalid';
        } else {
          sizeMessage.textContent = replaceToken(messages.exactConfirmed, '[count]', targetQuantity);
          sizeMessage.dataset.state = 'valid';
        }

        if (!state.invalidNumber && state.total === targetQuantity && !state.variantId) {
          pricingAlert.hidden = false;
          pricingAlert.textContent = messages.tierMissing;
        } else {
          pricingAlert.hidden = true;
          pricingAlert.textContent = '';
        }

        submitButton.disabled = state.invalidNumber || state.total !== targetQuantity || !state.variantId;
        if (!formError.hidden && formElement.checkValidity()) {
          formError.hidden = true;
          formError.textContent = '';
        }
      };

      const publicProperties = (state, formElement) => {
        const entries = Array.from(new FormData(formElement).entries())
          .filter((entry) => entry[0].startsWith('properties[') && !(entry[1] instanceof File) && String(entry[1]).trim() !== '')
          .map((entry) => [entry[0].slice(11, -1), String(entry[1]).trim()]);
        const properties = Object.fromEntries(entries);
        Object.entries(sizeLabels).forEach((entry) => {
          properties[entry[1] + ' quantity'] = String(state.values[entry[0]]);
        });
        properties['Total quantity'] = String(state.total);
        properties['Base package price'] = money(baseCents);
        Object.keys(surcharges).forEach((size) => {
          const label = sizeLabels[size];
          const quantity = state.values[size];
          properties[label + ' addition'] = quantity + ' x ' + money(surcharges[size]) + ' = ' + money(quantity * surcharges[size]);
        });
        properties['Extended-size additions'] = money(state.additions);
        properties['Configured merchandise subtotal'] = money(state.configuredCents);
        return properties;
      };

      const configurationSignature = (state, properties) => JSON.stringify({
        variantId: String(state.variantId || ''),
        total: state.total,
        additions: state.additions,
        configuredCents: state.configuredCents,
        properties: Object.keys(properties).sort().map((key) => [key, properties[key]])
      });

      const captureCurrentConfiguration = (reportValidity) => {
        const formElement = currentForm();
        const state = pricingState();
        const properties = publicProperties(state, formElement);
        return {
          ...state,
          formElement,
          requiredValid: validateCurrentRequiredState(formElement, reportValidity),
          color: currentFieldValue(root.dataset.colorFieldId),
          printColor: currentFieldValue(root.dataset.printColorFieldId),
          properties,
          signature: configurationSignature(state, properties)
        };
      };

      const closeModal = (focusTarget) => {
        if (saveInFlight) return;
        modal.hidden = true;
        document.body.style.overflow = modal.dataset.previousBodyOverflow || '';
        modalError.hidden = true;
        modalError.textContent = '';
        pendingState = null;
        modal.removeAttribute('data-configuration-signature');
        const returnTarget = focusTarget || modalReturnFocus;
        if (returnTarget) returnTarget.focus();
        modalReturnFocus = null;
      };

      const renderModal = (state) => {
        const fulfillment = state.properties['Fulfillment method'];
        root.querySelector('[data-lfg-delivery]').textContent = fulfillment === 'Ship my order' ? messages.ship : messages.pickup;
        root.querySelector('[data-lfg-delivery-confirm]').checked = false;
        modalBuyButton.textContent = editContext ? messages.save : modalBuyLabel;
        modalColor.textContent = state.color;
        modalPrintColor.textContent = state.printColor || 'Confirmed after checkout';
        modalTotal.textContent = state.total + ' ' + (state.total === 1 ? unitSingular : unitPlural);
        modalBase.textContent = compactMoney(baseCents);
        modalAdditions.textContent = compactMoney(state.additions);
        modalSubtotal.textContent = compactMoney(state.configuredCents);
        modalSizes.replaceChildren();

        Object.entries(sizeLabels).forEach((entry) => {
          const size = entry[0];
          const label = entry[1];
          const quantity = state.values[size];
          if (quantity < 1) return;
          const item = document.createElement('li');
          const surcharge = surcharges[size] || 0;
          item.textContent = surcharge
            ? label + ': ' + quantity + ' × ' + compactMoney(surcharge) + ' = ' + compactMoney(quantity * surcharge)
            : label + ': ' + quantity + ' — ' + messages.included;
          modalSizes.appendChild(item);
        });

        modalError.hidden = true;
        modalError.textContent = '';
        modalBuyButton.disabled = false;
      };

      const handleFormMutation = () => {
        pendingState = null;
        modal.removeAttribute('data-configuration-signature');
        update();
      };

      form.addEventListener('input', handleFormMutation);
      form.addEventListener('change', handleFormMutation);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (restoring || saveInFlight || saved) return;
        pendingState = null;
        modal.removeAttribute('data-configuration-signature');
        update();
        const state = captureCurrentConfiguration(true);

        if (!state.requiredValid) {
          formError.hidden = false;
          formError.textContent = messages.requiredError;
          return;
        }

        if (state.invalidNumber || state.total !== targetQuantity) {
          formError.hidden = false;
          formError.textContent = replaceToken(messages.sizeError, '[count]', targetQuantity);
          formError.focus();
          return;
        }

        if (!state.variantId) {
          formError.hidden = false;
          formError.textContent = messages.tierMissing;
          formError.focus();
          return;
        }

        formError.hidden = true;
        pendingState = state;
        modal.dataset.configurationSignature = state.signature;
        modalReturnFocus = event.submitter || submitButton;
        renderModal(state);
        modal.dataset.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        modal.hidden = false;
        modalPanel.scrollTop = 0;
        modalEditButton.focus({ preventScroll: true });
      });

      modalEditButton.addEventListener('click', () => closeModal());

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeModal();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [modalEditButton, modalBuyButton].filter((button) => !button.disabled);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      modalBuyButton.addEventListener('click', async () => {
        if (!pendingState || modalBuyButton.disabled) return;
        const state = captureCurrentConfiguration(false);
        if (
          !state.requiredValid
          || state.invalidNumber
          || state.total !== targetQuantity
          || !state.variantId
          || state.signature !== pendingState.signature
          || state.signature !== modal.dataset.configurationSignature
        ) {
          pendingState = null;
          modalBuyButton.disabled = true;
          modalError.hidden = false;
          modalError.textContent = messages.configurationChanged;
          modalError.focus();
          return;
        }
        const confirmation = root.querySelector('[data-lfg-delivery-confirm]');
        if (!confirmation.checked) {
          modalError.hidden = false;
          modalError.textContent = messages.confirmError;
          confirmation.focus();
          return;
        }
        const properties = { ...state.properties };
        properties['Checkout delivery'] = properties['Fulfillment method'] === 'Ship my order' ? messages.checkoutShip : messages.checkoutPickup;
        saveInFlight = true;
        state.formElement.inert = true;
        modalBuyButton.disabled = true;
        modalEditButton.disabled = true;
        modalBuyButton.textContent = messages.saving;
        try {
          await window.LfgBundleCart.save({ state, properties, edit: editContext, messages });
          saved = true;
          window.location.assign(window.Shopify.routes.root + (editContext ? 'cart' : 'checkout'));
        } catch (error) {
          modalError.hidden = false;
          modalError.textContent = error.message || messages.addError;
          root.querySelector('[data-lfg-review-cart]').hidden = false;
          modalError.focus();
          modalBuyButton.disabled = false;
          modalBuyButton.textContent = editContext ? messages.save : modalBuyLabel;
        } finally {
          saveInFlight = false;
          state.formElement.inert = false;
          modalEditButton.disabled = false;
        }
      });

      const restoringEdit = new URLSearchParams(location.search).has('lfg_edit');
      root.querySelector('[data-lfg-loading]').hidden = !restoringEdit;
      form.inert = restoringEdit;
      update();
      if (restoringEdit) submitButton.disabled = true;
      (async () => {
        try {
          if (!window.LfgBundleCart) throw new Error(messages.editUnavailable);
          editContext = await window.LfgBundleCart.restore(root, messages);
          root.querySelector('[data-lfg-edit-banner]').hidden = !editContext;
          restoring = false;
          form.inert = false;
          update();
        } catch (error) {
          const notice = root.querySelector('[data-lfg-edit-error]');
          notice.hidden = false; notice.textContent = error.message;
          root.querySelector('[data-lfg-review-cart]').hidden = false;
          submitButton.disabled = true;
        } finally {
          root.querySelector('[data-lfg-loading]').hidden = true;
        }
      })();
      window.addEventListener('pageshow', () => {
        if (saved) {
          submitButton.disabled = true;
          modalBuyButton.disabled = true;
          root.querySelector('[data-lfg-review-cart]').hidden = false;
        }
      });
    };

    document.querySelectorAll('[data-lfg-retail]').forEach(initializeRetail);
    document.querySelectorAll('[data-lfg-bundle]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initializeRetail(event.target.querySelector('[data-lfg-retail]'));
      initialize(event.target.querySelector('[data-lfg-bundle]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lfg-quantity-checkout"] && !Shopify.designMode) return;
  try {
    

(() => {
  document.querySelectorAll('[data-lfg-qc]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.dataset.variants);
    const fullColor = root.dataset.offerMode === 'full-color';
    const bySize = Object.fromEntries(variants.map(v => [v.option1, v]));
    const form = root.querySelector('form');
    const color = root.querySelector('[data-color]');
    const artwork = root.querySelector('[data-artwork]');
    const fileStatus = root.querySelector('[data-file-status]');
    const inputs = [...root.querySelectorAll('[data-size]')];
    const buy = root.querySelector('[data-buy]');
    const error = root.querySelector('[data-error]');
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents/100);
    let submitting = false;
    let locked = false;

    function state() {
      const sizes = Object.fromEntries(inputs.map(i => [i.dataset.size, Number(i.value || 0)]));
      const integerSizes = Object.values(sizes).every(n => Number.isInteger(n) && n >= 0 && n <= 99);
      const total = Object.values(sizes).reduce((a,b) => a+b, 0);
      const discount = total >= 50 ? 502 : total >= 24 ? 300 : 0;
      const validTotal = fullColor ? total === 12 : total >= 12 && total <= 99;
      const unit = fullColor ? (validTotal ? 1125 : 0) : (validTotal ? 1200-discount : 0);
      const selected = Object.entries(sizes).filter(([,q]) => q > 0);
      const available = selected.every(([size]) => bySize[size] && bySize[size].available);
      const referencePrice = fullColor ? 1125 : 1200;
      const rawAdditions = selected.reduce((sum,[size,qty]) => sum + qty * Math.max(0,(bySize[size]?.price || referencePrice)-referencePrice), 0);
      const additions = validTotal ? rawAdditions : 0;
      return {sizes,total,unit,tier:unit ? money(unit)+' each' : '—',base:total*unit,additions,grand:total*unit+additions,
        valid:integerSizes && validTotal && Boolean(color.value) && available};
    }

    function render() {
      const s = state();
      root.querySelector('[data-total]').textContent = s.total;
      root.querySelector('[data-tier]').textContent = s.tier;
      root.querySelector('[data-base]').textContent = money(s.base);
      root.querySelector('[data-additions]').textContent = money(s.additions);
      root.querySelector('[data-grand]').textContent = money(s.grand);
      const status = root.querySelector('[data-status]');
      status.textContent = s.total < 12 ? ('Add '+(12-s.total)+' more to reach '+(fullColor ? 'exactly 12 shirts.' : 'the 12-shirt minimum.')) : fullColor && s.total > 12 ? 'This offer is for exactly 12 shirts.' : !fullColor && s.total > 99 ? 'Orders of 100 or more require a quote.' : !color.value ? 'Choose one shirt color.' : !s.valid ? 'Check size quantities and availability.' : 'Ready to purchase.';
      status.dataset.valid = String(s.valid);
      buy.disabled = !s.valid || submitting || locked;
    }

    artwork.addEventListener('change', () => {
      error.hidden = true;
      const file = artwork.files && artwork.files[0];
      if (!file) { fileStatus.textContent='No file selected.'; return; }
      if(file.size > 20*1024*1024 || !/\.(pdf|png|jpe?g|svg|ai|eps)$/i.test(file.name)) {
        artwork.value='';
        fileStatus.textContent='No file selected.';
        error.textContent='Choose PDF, PNG, JPG, SVG, AI or EPS artwork up to 20 MB, or send artwork after checkout.';
        error.hidden=false;
        return;
      }
      fileStatus.textContent='Ready to attach: '+file.name;
    });

    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const s=state();
      if(submitting || locked || !s.valid) return render();
      submitting=true;
      buy.disabled=true;
      buy.textContent='STARTING SECURE CHECKOUT…';
      error.hidden=true;
      const breakdown=Object.entries(s.sizes).filter(([,q])=>q>0).map(([z,q])=>z+': '+q).join(', ');
      const ref='LFG-'+Date.now()+'-'+Math.random().toString(36).slice(2,8);
      const file=artwork.files && artwork.files[0];
      const properties={
        'Shirt color':color.value,
        'Size breakdown':breakdown,
        'Total quantity':String(s.total),
        'Quantity price tier':s.tier,
        'Artwork status':file?'Uploaded with order':'Customer will send after checkout',
        'Remaining production details':'Confirmed after checkout',
        'Bundle reference':ref,
        '_LFG configured order':'true'
      };
      const items=Object.entries(s.sizes).filter(([,q])=>q>0).map(([size,quantity])=>({
        id:bySize[size].id,quantity,properties:{...properties}
      }));
      const baseUrl=window.Shopify.routes.root;
      try {
        let body, headers={'Accept':'application/json'};
        if(file) {
          body=new FormData();
          items.forEach((item,index)=>{
            body.append('items['+index+'][id]',String(item.id));
            body.append('items['+index+'][quantity]',String(item.quantity));
            Object.entries(item.properties).forEach(([key,value])=>body.append('items['+index+'][properties]['+key+']',value));
          });
          body.append('items[0][properties][Artwork file]',file,file.name);
        } else {
          headers['Content-Type']='application/json';
          body=JSON.stringify({items});
        }
        const response=await fetch(baseUrl+'cart/add.js',{method:'POST',headers,body});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description || result.message || 'Could not add this order.');
        window.location.assign(baseUrl+'checkout');
      } catch(err) {
        try {
          const cartResponse=await fetch(baseUrl+'cart.js',{headers:{'Accept':'application/json'}});
          if(!cartResponse.ok) throw new Error('Cart check failed');
          const cart=await cartResponse.json();
          const added=cart.items.filter(item=>item.properties && item.properties['Bundle reference']===ref);
          if(added.length) {
            locked=true;
            error.textContent='Your cart contains items from this attempt. Review the cart before continuing to avoid duplicate shirts. ';
            const link=document.createElement('a');
            link.href=baseUrl+'cart'; link.textContent='Review cart';
            error.append(link);
          } else {
            error.textContent=(err.message || 'Could not start checkout.')+' You can remove the file and try again, or call 972-840-8337.';
          }
        } catch {
          locked=true;
          error.textContent='We could not confirm whether your cart was updated. Check your cart before trying again to avoid duplicate shirts. ';
          const link=document.createElement('a');
          link.href=baseUrl+'cart'; link.textContent='Review cart';
          error.append(link);
        }
        error.hidden=false;
        submitting=false;
        buy.textContent='BUY NOW';
        render();
      }
    });
    render();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
